import React, {useContext} from "react";
import {Link} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";

// (conversationId) => path of the conversation; when not provided, the legacy flow supervision page is used
export const ConversationHrefContext = React.createContext(null);

export const ConversationLink = ({projectId, conversationId}) => {
  const conversationHref = useContext(ConversationHrefContext);
  if (!conversationId) return "-";
  return (
    <Link
      component={RouterLink}
      to={conversationHref ? conversationHref(conversationId) : `/project/${projectId}/supervision/${conversationId}`}
      onClick={(e) => e.stopPropagation()}
    >
      #{conversationId}
    </Link>
  )
}
